import {observable, action} from 'mobx';
import shortid from 'shortid';
import _ from 'lodash';
class CreateTutorialStore {

  @observable tutorial = _.assign({},
    {title: '',
      description: '',
      video_url: '',
      friendly_id_url: '',
      spd_quizzes:[{
        question: '',
        correct: null
      }],
      cpd_status: false,
      icgp_number: '',
      cpd_points: ''
      // questions: [{
      //   start_time: '',
      //   stubKey: _.assign(shortid.generate()),
      //   end_time: '',
      //   thumbnail: '',
      //   title: ''
      // }]
    });

  @observable errors = {};

  @action
  setTutorial = tutorial => {
    // let questions = tutorial.questions;
    // _.map(questions, el => {
    //   return _.assign(el, {stubKey: _.assign(shortid.generate())});
    // });
    this.tutorial = tutorial;
  };

  @action
  initNewTutorial = () => {
   this.tutorial = _.assign({},{
    title: '',
    description: '',
    video_url: '',
    friendly_id_url: '',
    spd_quizzes:[{
      question: '',
      correct: ''
    }],
    cpd_status: false,
    icgp_number: '',
    cpd_points: ''
      //  questions: [{
      //    start_time: '',
      //    stubKey: _.assign(shortid.generate()),
      //    end_time: '',
      //    thumbnail: '',
      //    title: ''
      //  }]
   })
  };

  @action
  handleChange = data => {
    _.assign(this.tutorial, data)
  };

  @action
  handleChangePreview = (data, stubKey) => {
    let previewIndex = _.findIndex(this.tutorial.questions, el => el.stubKey === stubKey);
    const newQuestion = _.assign({}, this.tutorial.questions[previewIndex], data);
    this.tutorial.questions[previewIndex] = newQuestion
  };

  @action
  addQuestion = () => {
    this.tutorial.questions.push(_.assign({}, {
      start_time: '',
      stubKey: _.assign(shortid.generate()),
      end_time: '',
      thumbnail: '',
      title: ''
    }))
  };

  getQuestionbyStubKey = stubKey => {
    let previewIndex = _.findIndex(this.tutorial.questions, el => el.stubKey === stubKey);
    return this.tutorial.questions[previewIndex];
  };

  @action
  removeQuestion = stubKey => {
    let previewIndex = _.findIndex(this.tutorial.questions, el => el.stubKey === stubKey);
    let question = this.tutorial.questions[previewIndex];
    if(question.id){
      this.tutorial.questions[previewIndex] = {['_destroy']: true, id: question.id, stubKey: question.stubKey}
    }
    else
      this.tutorial.questions.splice(previewIndex, 1);
  };

  @action initQuestions = questions => {
    _.map(questions, el => {
      return _.assign(el, {stubKey: _.assign(shortid.generate())});
    });
    this.tutorial.questions = questions;
  };

  removeIcon = () => {
    let count = 0;
    this.tutorial.questions.forEach(el => {
      if(!el._destroy)
        count++;
    });
    return count > 1
  };

  @action
  setError = errors => {
    this.errors = errors;
  };

  getErrorToQuestion = stubKey => {
    if(!this.errors)
      return {};
    const index = _.findIndex(this.errors.questions, el => el.stubKey === stubKey);
    if(index === -1)
      return {};
    return this.errors.questions[index];
  };

  @action handleChangeQuiz = data => {
    this.tutorial.spd_quizzes = data;
  }

  @action handleChangeCPDOptions = (key, value) => {
    this.tutorial[key] = value;
  }

  @action
  getErrorToQuiz = i => {
    if(!this.errors)
      return {};
    const index = _.findIndex(this.errors.spd_quizzes, el => el.i === i);
    if(index === -1)
      return {};
    return this.errors.spd_quizzes[index];
  };
}

export default new CreateTutorialStore();



// WEBPACK FOOTER //
// ./src/stores/CreateTutorialStore.js